//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSyncLogDetail, triggerSync } from "@/api/syncLog";
export default {
  name: "SyncDetail",
  data: function data() {
    return {
      open: false,
      loading: false,
      syncInfo: {}
    };
  },
  methods: {
    /** 显示详情 */show: function show(id) {
      this.open = true;
      this.loading = true;
      this.getSyncDetail(id);
    },
    /** 获取同步详情 */getSyncDetail: function getSyncDetail(id) {
      var _this = this;
      getSyncLogDetail(id).then(function (response) {
        _this.syncInfo = response.data;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    /** 重试同步 */handleRetry: function handleRetry() {
      var _this2 = this;
      this.$modal.confirm("确认要重试该同步任务吗？").then(function () {
        return triggerSync(_this2.syncInfo.syncType);
      }).then(function () {
        _this2.$modal.msgSuccess("重试任务已启动");
        _this2.open = false;
        _this2.$emit('retry');
      });
    },
    /** 获取成功率 */getSuccessRate: function getSuccessRate(syncInfo) {
      if (!syncInfo.totalCount) return 0;
      return Math.round(syncInfo.successCount / syncInfo.totalCount * 100);
    },
    /** 获取进度条颜色 */getProgressColor: function getProgressColor(syncInfo) {
      var rate = this.getSuccessRate(syncInfo);
      if (rate === 100) return '#67C23A';
      if (rate >= 80) return '#E6A23C';
      return '#F56C6C';
    },
    /** 获取耗时 */getDuration: function getDuration(syncInfo) {
      if (!syncInfo.createTime) return '-';
      var startTime = new Date(syncInfo.createTime).getTime();
      var endTime = syncInfo.endTime ? new Date(syncInfo.endTime).getTime() : Date.now();
      var duration = Math.round((endTime - startTime) / 1000);
      if (duration < 60) return "".concat(duration, "\u79D2");
      if (duration < 3600) return "".concat(Math.floor(duration / 60), "\u5206").concat(duration % 60, "\u79D2");
      return "".concat(Math.floor(duration / 3600), "\u65F6").concat(Math.floor(duration % 3600 / 60), "\u5206");
    },
    /** 格式化时间 */formatTime: function formatTime(time) {
      return new Date(time).toLocaleTimeString();
    },
    /** 获取日志样式类 */getLogClass: function getLogClass(level) {
      return "log-".concat(level.toLowerCase());
    },
    /** 获取日志标签类型 */getLogTagType: function getLogTagType(level) {
      var typeMap = {
        'INFO': 'info',
        'WARN': 'warning',
        'ERROR': 'danger',
        'DEBUG': ''
      };
      return typeMap[level.toUpperCase()] || 'info';
    },
    /** 获取操作类型标签 */getOperationTagType: function getOperationTagType(operationType) {
      var typeMap = {
        'CREATE': 'success',
        'UPDATE': 'warning',
        'DELETE': 'danger'
      };
      return typeMap[operationType] || 'info';
    },
    /** 获取操作类型文本 */getOperationText: function getOperationText(operationType) {
      var textMap = {
        'CREATE': '新增',
        'UPDATE': '更新',
        'DELETE': '删除'
      };
      return textMap[operationType] || operationType;
    },
    /** 获取同步类型标签类型 */getSyncTypeTagType: function getSyncTypeTagType(syncType) {
      var typeMap = {
        'business': 'primary',
        'store': 'success',
        'full': 'warning'
      };
      return typeMap[syncType] || 'info';
    },
    /** 获取同步类型文本 */getSyncTypeText: function getSyncTypeText(syncType) {
      var typeMap = {
        'business': '商户同步',
        'store': '门店同步',
        'full': '全量同步'
      };
      return typeMap[syncType] || '未知';
    },
    /** 获取状态标签类型 */getStatusTagType: function getStatusTagType(status) {
      var statusMap = {
        'running': 'warning',
        'success': 'success',
        'failed': 'danger'
      };
      return statusMap[status] || 'info';
    },
    /** 获取状态文本 */getStatusText: function getStatusText(status) {
      var statusMap = {
        'running': '同步中',
        'success': '成功',
        'failed': '失败'
      };
      return statusMap[status] || '未知';
    }
  }
};